import * as yup from 'yup'

import { driverDocumentsSchema } from 'features/Drivers/components/DriverDocumentsCard/schema'
import { INewDriverStep2 } from 'features/Drivers/types'

export const driverStep2Schema = (): yup.SchemaOf<INewDriverStep2> => {
  return yup.object().shape({
    documents: driverDocumentsSchema()
  })
}
